module.exports = __webpack_public_path__ + "img/book-03.948ccc33.png";